import { api } from "services/api.service";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";

export async function action({ params }: { params: Record<string, string | undefined> }) {
  const res = await withActionErrorAlert(() =>
    api.request({ method: "DELETE", url: `/location_management/kind_movement_rules/${params.kindMovementRuleId}` }),
  );
  if (res?.status && res.status < 400) {
    return redirect(`/kind-movements?reload=${Date.now()}`);
  }
  return res;
}
